import React from "react"
class Message extends React.Component {
	constructor(props) {
		super(props)
		this.state = { ...props }
		this.mounted = false
	}
	componentDidMount() {
		this.mounted = true
		setTimeout(
			() => {
				if (this.mounted) this.setState({ removing: true })
			},
			this.state.timeOut === undefined ? 3000 : this.state.timeOut
		)
	}
	componentWillUnmount() {
		this.mounted = false
	}
	render() {
		if (this.state.remove) return null
		return (
			<div
				className={
					"position-fixed top-2 right-2 bottom-auto left-auto message" +
					(this.state.removing ? " hidden" : "")
				}
				onClick={() => {
					this.setState({ removing: true })
				}}
				onTransitionEnd={() => {
					this.setState({ remove: true })
					if (this.state.closeMessage !== undefined)
						this.state.closeMessage()
				}}
			>
				<div
					className={
						"bg-" +
						this.state.mode +
						" text-" +
						(["warning", "light"].indexOf(this.state.mode) >= 0
							? "dark"
							: "white") +
						" p-3"
					}
				>
					<>
						{this.state.text !== undefined ? this.state.text : ""}
						{this.state.text !== undefined &&
						this.state.text !== "" &&
						this.state.children !== undefined &&
						this.state.children !== "" ? (
							<br />
						) : (
							""
						)}
						{this.state.children !== undefined
							? this.state.children
							: ""}
					</>
				</div>
			</div>
		)
	}
}
export default Message
